import { createSelector } from '@ngrx/store'
import { RootState } from '../root.model'
import { ReportingRedux } from './reporting.reducer'

const reportingState = (state: RootState) => state.reporting

export const selectFocusedMyAccount = createSelector(
  reportingState,
  (state: ReportingRedux) => state.myAccount,
)
